import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ManagementCompany } from "src/pages/Admin/ManagmentCompanies/types";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

export async function updateManagementCompanyRequest({
	managementCompanyId,
	cif
}: ManagementCompany) {
	return await apiClient
		.put(API.COMMAND.ADMIN.UPDATE_MANAGEMENT_COMPANY, { managementCompanyId, cif })
		.then((res) => res.data);
}

export function useUpdateManagementCompany() {
	return useMutation<any, AxiosError, any>({
		mutationFn: (payload: ManagementCompany) => updateManagementCompanyRequest(payload)
	});
}
